// Small rounded pill. `tone` sets the color; `trend` on a numeric value picks
// up/down/neutral automatically and prepends an arrow.
const TONES = {
  up: 'bg-green-50 text-green-700 ring-green-600/20 dark:bg-green-500/15 dark:text-green-300 dark:ring-green-400/30',
  down: 'bg-red-50 text-red-600 ring-red-600/20 dark:bg-red-500/15 dark:text-red-300 dark:ring-red-400/30',
  neutral: 'bg-slate-100 text-slate-500 ring-slate-400/20 dark:bg-white/10 dark:text-slate-300 dark:ring-white/15',
  brand: 'bg-brand/10 text-brand-dark ring-brand/20 dark:bg-brand/20 dark:text-brand-light dark:ring-brand/30',
};

export function Badge({ children, tone = 'neutral', className = '' }) {
  return (
    <span className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold ring-1 ring-inset ${TONES[tone] || TONES.neutral} ${className}`}>
      {children}
    </span>
  );
}

// A ▲/▼ percent pill for MoM-style values. null → em dash.
export function TrendBadge({ value }) {
  if (value === null || value === undefined) {
    return <Badge tone="neutral">—</Badge>;
  }
  const n = Number(value);
  const tone = n > 0 ? 'up' : n < 0 ? 'down' : 'neutral';
  const arrow = n > 0 ? '▲' : n < 0 ? '▼' : '•';
  const sign = n > 0 ? '+' : '';
  return <Badge tone={tone}>{arrow} {sign}{n.toFixed(1)}%</Badge>;
}
